/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable, NgModule } from '@angular/core';
import { CanDeactivate, RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { RequestsListComponent } from '@app/sales/requests/requests-list/requests-list.component';
import { SalesListComponent } from '@app/sales/sales/sales-list/sales-list.component';
import { SalesViewComponent } from '@app/sales/sales/sales-view/sales-view.component';
import { MenuService } from '@app/core/menu/menu.service';
import { CommentsService } from '@app/shared/components/comments/comments-service.service';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { GuestNamesListComponent } from '@app/sales/guest-names-list/guest-names-list.component';

@Injectable()
export class ConfirmDeactivateGuard implements CanDeactivate<SalesViewComponent> {
  constructor(public commentsService: CommentsService) {}

  canDeactivate() {
    if (this.commentsService.hasValue) {
      return swal
        .fire({
          title: 'Are you sure?',
          text: 'Your comment will be lost',
          showConfirmButton: true,
          showCancelButton: true,
          type: 'warning',
        } as SweetAlertOptions)
        .then((res) => {
          // SweetAlert2 v11 returns `isConfirmed` for confirm actions.
          // Normalize possible response shapes and return a strict boolean.
          return !!(res && (res.value || res.isConfirmed));
        });
    }
    return true;
  }
}

const routes: Routes = [
  Shell.childRoutes([
    { path: 'enquiries', component: RequestsListComponent, data: { title: extract('Enquiries') } },
    { path: 'sales', component: SalesListComponent, data: { title: extract('Sales') } },
    {
      path: 'sales/view',
      component: SalesViewComponent,
      canDeactivate: [ConfirmDeactivateGuard],
      data: { title: extract('Sales view') },
    },
    { path: 'guest_names', component: GuestNamesListComponent, data: { title: extract('Guest names') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'sales',
        title: 'Sales',
        icon: 'fal fa-hand-holding-usd',
      })
      .addItem({
        key: 'sales.sales',
        title: 'Clients requests',
        requiredPermission: 'sales.menu',
        path: '/sales',
      })
      .addItem({
        key: 'sales.enquiries',
        title: 'Enquiries',
        requiredPermission: 'enquiries.menu',
        path: '/enquiries',
      })
      .addItem({
        key: 'sales.guest_names',
        title: 'Guest names',
        path: '/guest_names',
      });
  }
}
